module.exports = "<div ng-class=::vm.stateContext> <i class=ico ng-class=::vm.stateIcon></i> {{ ::vm.state.name }} </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/order-state.html
// module id = 533
// module chunks = 0